import { useTranslations } from "use-intl";

import { BottomNavClient, type BottomNavLabels } from "./bottom-nav-client";

export function BottomNav() {
  const t = useTranslations("globals.bottomNav");
  const tOffers = useTranslations("shared.affiliates");
  const labels: BottomNavLabels = {
    home: t("home"),
    offers: tOffers("offersNavLabel"),
    community: t("community"),
    signIn: t("signIn"),
  };
  return <BottomNavClient labels={labels} />;
}
